export const Aside = () => {
  return <aside className="h-screen w-0 bg-jutro-new-green-400 xl:w-1/4" />;
};
